<style scoped>
    @import url("../../styles/mv/imgDevice.scss");
</style>

<template>
    
    <div class="box_imgDevice">

        <div class="el_img"
        :style="{
            backgroundImage:'url(' + require('../../assets/st-q.png') + ')',
            backgroundSize: 'cover', // contain
            backgroundPosition: 'bottom' // top center
        }"
        ></div>

        <!--<v-img class="el_img" 
        :src="require('../../assets/imgMainV2_t0.webp')" '../../assets/capa-up-t1.png'
        ></v-img>-->
            
    </div>

</template>

<script>
export default {

    props:['flagImg'],

    data() {
        return {
            //
        }
    },

    methods: {
        //
    },

    created() {
        //this.$store.commit('srcIP') // without param. Initial main GET Req.
    }
}

</script>